<template>
  <div v-if="isLoading" class="text-center py-12">
    <v-progress-circular indeterminate size="64"></v-progress-circular>
  </div>
  <div
    v-else-if="!hasData"
    class="text-center py-12"
    :style="{ height: height }"
  >
    No data available
  </div>
  <highcharts v-else :options="chartOptions" :callback="onCallbackChart" />
</template>

<script>
import VueHighcharts from "@evercam/shared/components/Highcharts"

export default {
  name: "PosthogEventsStatsHighchart",
  components: {
    highcharts: VueHighcharts,
  },
  props: {
    chartData: {
      type: Object,
      default: () => ({}),
    },
    height: {
      type: String,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      initialChartOptions: {
        chart: {
          type: "line",
          zoomType: "xy",
          height: this.height,
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: [],
          title: {
            text: "Date",
          },
          crosshair: true,
        },
        yAxis: {
          title: {
            text: "Events Count",
          },
          min: 0,
        },
        tooltip: {
          shared: true,
          useHTML: true,
          headerFormat: '<table><tr><th colspan="2">{point.key}</th></tr>',
          pointFormat:
            '<tr><td style="color: {series.color}">{series.name}: </td>' +
            '<td style="text-align: right"><b>{point.y}</b></td></tr>',
          footerFormat: "</table>",
          valueDecimals: 0,
        },
        plotOptions: {
          series: {
            cursor: "pointer",
            point: {
              events: {
                click: this.onClickChartSeriesPoint,
              },
            },
          },
          line: {
            marker: {
              enabled: true,
              radius: 4,
            },
          },
        },
        legend: {
          layout: "horizontal",
          align: "center",
          verticalAlign: "bottom",
          itemStyle: {
            fontWeight: "normal",
          },
        },
        colors: [
          "#7cb5ec",
          "#434348",
          "#90ed7d",
          "#f7a35c",
          "#8085e9",
          "#f15c80",
          "#e4d354",
          "#2b908f",
          "#f45b5b",
          "#91e8e1",
        ],
      },
      chartOptions: {},
    }
  },
  computed: {
    hasData() {
      return (
        this.chartData?.datasets?.length > 0 &&
        this.chartData?.highchartsLabels?.length > 0
      )
    },
  },
  watch: {
    chartData: {
      async handler() {
        await this.initializeChart()
      },
      deep: true,
    },
  },
  mounted() {
    this.chartOptions = { ...this.initialChartOptions }
    this.initializeChart()
  },
  methods: {
    initializeChart() {
      if (!this.chartData.highchartsLabels || !this.chartData.datasets) {
        return
      }

      this.chartOptions = {
        ...this.chartOptions,
        xAxis: {
          ...this.chartOptions.xAxis,
          categories: this.chartData.highchartsLabels,
        },
        series: this.chartData.datasets.map((dataset) => ({
          name: dataset.label,
          data: dataset.data,
          color: dataset.borderColor,
          type: this.initialChartOptions.chart.type || "line",
          marker: {
            enabled: true,
            radius: 4,
          },
        })),
      }
    },
    onCallbackChart() {
      if (
        !this.chartData.highchartsLabels ||
        this.chartData.highchartsLabels.length === 0
      ) {
        this.chartOptions.title.text = "No data available"

        return
      }
      this.chartOptions.title.text = ""
    },
    onClickChartSeriesPoint(event) {
      this.$emit("click-chart-point", event.point)
    },
  },
}
</script>
